<template>
    <div>
        <nav-bar v-if="$route.path!='/course/studyCourse'"></nav-bar>
        <div v-if="$route.path=='/course'">
            <page-content ref="page_content animate__animated animate__fadeIn"></page-content>
            <bottom-slider></bottom-slider>
        </div>
        <router-view v-else></router-view>
    </div>
</template>

<script>
import PageContent from '@/components/course/PageContent.vue';
    export default {
        components:{PageContent},
        beforeRouteLeave(to,form,next){
            let c=this.$refs.page_content;
            c&&c.initVPages();
            next();
        },
    }
</script>

<style lang="less" scoped>

</style>